export default [
  {
    title: "دوربین هوش مصنوعی",
    icon: "HomeIcon",
    route: "ai-camera-personnel",
  },
];
